import { useNotificationsCenter } from '@contexts/NotificationsCenterContext';
import { Popover } from 'antd';
import { useEffect } from 'react';
import NotificationsCenter from '../NotificationsCenter/NotificationsCenter';

function NotificationsPopover() {
  const { popoverVisible, setPopoverVisible } = useNotificationsCenter();

  useEffect(() => {
    if (!popoverVisible) return;

    const closeOnOutsideClick = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Node)) return;

      const notificationIcon = document.getElementById('topbar-notification-icon');
      const notificationButton = notificationIcon?.closest('button, [role="button"]');
      const notificationTrigger = notificationButton ?? notificationIcon?.parentElement;
      const notificationPopover = document.querySelector('.notifications-center-popover');

      if (notificationTrigger?.contains(target) || notificationPopover?.contains(target)) return;
      setPopoverVisible(false);
    };

    document.addEventListener('click', closeOnOutsideClick);
    return () => document.removeEventListener('click', closeOnOutsideClick);
  }, [popoverVisible, setPopoverVisible]);

  const popoverPlacement = 'bottomRight';
  const popoverAligment = { offset: [-40, 5] };

  return (
    <Popover
      visible={popoverVisible}
      align={popoverAligment}
      placement={popoverPlacement}
      content={<NotificationsCenter />}
      trigger={[]}
      destroyTooltipOnHide
      overlayClassName={
        'notifications-center-popover [&_.ant-popover-inner]:rounded-lg [&_.ant-popover-inner-content]:p-0 [&_.ant-popover-arrow]:hidden  [&_.anticon]:!text-[#0E7059] [&_.anticon:hover]:!text-[#0E7059]'
      }
    />
  );
}

export { NotificationsPopover };
